import type { ContactTopicId } from '../../../utils/contact-topics.util';

export type NavDropdownLink = { href: string; text: string };

export type NavMenuDropdownEntry =
  | { kind: 'link'; href: string; text: string }
  | { kind: 'group'; groupLabel: string; items: NavDropdownLink[] };

export type NavMenuItem =
  | {
      href: string;
      text: string;
      /**
       * Opens the shared contact dialog instead of following `href`. The
       * `mailto:` in `href` stays as the no-JS fallback the static nav bar in
       * `primaryNavigation.tsx` renders.
       */
      contactTopic?: ContactTopicId;
    }
  | {
      text: string;
      dropdown: NavMenuDropdownEntry[];
    };

export const NAV_ITEMS: NavMenuItem[] = [
  { href: '/#home', text: 'Home' },
  {
    text: 'Products',
    dropdown: [
      {
        kind: 'group',
        groupLabel: 'Products',
        items: [
          { href: '/products/shelter-sense', text: 'Shelter Sense' },
          { href: '/products/radio-demon', text: 'Radio Demon' },
          {
            href: 'https://app.theyoupowerproject.com',
            text: 'You Power Project',
          },
        ],
      },
    ],
  },
  { href: '/blog', text: 'Blog' },
  { href: '/about', text: 'About' },
  {
    href: 'mailto:mark@wilkins.software?subject=Contact%20form%20message',
    text: 'Contact',
    contactTopic: 'general-contact',
  },
];
